import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralize'
})
export class PluralizePipe implements PipeTransform {

  transform(value: number, key: string): unknown {
    switch (key) {
      case 'day':
        if (value === 1) {
          return `${value} ${key}`;
        }
        return `${value} ${key}s`;
      default:
        break;
    }
  }

}
